@if (isInitialized) {
  <oe-flat-widget button [modalComponent]="modalComponent"
    [icon]="{color: 'normal', name: 'flame', size: 'medium'}" [title]="component.alias">
    @if (isConnectionSuccessful) {
      <oe-flat-widget-line [name]="'GENERAL.STATE'|translate" [value]="statusValue">
      </oe-flat-widget-line>
    }
    <oe-flat-widget-line [name]="'GENERAL.MODE'| translate" [value]="mode | translate">
    </oe-flat-widget-line>
  </oe-flat-widget>
}